import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import ContentPageHero from '../components/ContentPageHero';
import Faq from '../components/Faq';
import Footer from '../components/Footer';
import { faqItems } from '../data/faq';

const FaqPage: React.FC = () => {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <Helmet>
        <title>FAQ | PH Therapy</title>
        <meta
          name="description"
          content="Common questions about exercise physiology, cancer rehabilitation, MSK care, and our services for partners and CEOs. London, Wimbledon, Fulham, Kensington, Chiswick, Surrey & Sussex."
        />
        <link rel="canonical" href="https://www.pandhtherapy.co.uk/faq" />
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      </Helmet>
      <Header />
      <main id="faq-page" className="faq-page">
        <ContentPageHero
          title="Frequently Asked Questions"
          description="Common questions about exercise physiology, our services, and what to expect at PH Therapy."
        />
        <section className="faq-page-content" aria-label="Frequently asked questions">
          <div className="container">
            <Faq showSections={true} />
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default FaqPage;
